/** Local-storage key persisting the user's analytics cookie choice across sessions. */
export const COOKIE_CONSENT_STORAGE_KEY = 'cnh_cookie_consent_analytics';

/** Analytics cookie consent states. `Unset` means the user has not chosen yet (banner visible). */
export const COOKIE_CONSENT_STATUS = {
  UNSET: 'unset',
  GRANTED: 'granted',
  DENIED: 'denied',
} as const;

export type CookieConsentStatus =
  (typeof COOKIE_CONSENT_STATUS)[keyof typeof COOKIE_CONSENT_STATUS];

/**
 * OneTrust CMP integration constants.
 *
 * The market-specific `data-domain-script` id is supplied per environment
 * (see `environment.cookieConsent.scriptId`). When configured, OneTrust renders its own banner and
 * becomes the source of truth for consent; the in-app banner is only a fallback for environments
 * where no script id is set.
 */
export const ONETRUST_SDK_STUB_URL = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';

/** DOM id for the injected OneTrust stub script tag. */
export const ONETRUST_SCRIPT_ID = 'cnh-onetrust-cmp-script';

/** OneTrust cookie category id for performance/analytics cookies (gates Pendo). */
export const ONETRUST_ANALYTICS_CATEGORY = 'C0002';

/** First-party cookie OneTrust writes with the visitor's consent choices. */
export const ONETRUST_CONSENT_COOKIE = 'OptanonConsent';

/** First-party cookie indicating the visitor dismissed the OneTrust banner. */
export const ONETRUST_ALERT_BOX_CLOSED_COOKIE = 'OptanonAlertBoxClosed';

/** `OptanonConsent.intType` value for banner "Accept all". */
export const ONETRUST_INTERACTION_ACCEPT_ALL = '1';

/** `OptanonConsent.intType` value for banner "Reject all". */
export const ONETRUST_INTERACTION_REJECT_ALL = '2';

/** User-facing copy for the analytics cookie consent banner. */
export const COOKIE_CONSENT_TEXT = {
  title: 'We value your privacy',
  message:
    'We use analytics cookies to understand how MyAccount is used so we can improve your experience. No personal information is collected. You can change your choice at any time.',
  acceptLabel: 'Accept analytics',
  declineLabel: 'Decline',
  ariaLabel: 'Analytics cookie consent',
} as const;
